import { Box, Slide, useTheme } from "@mui/material";
import React from "react";
import { CarouselProps } from "./types";
import { StyledBox, StyledMobileStepper } from "./styles";


const Carousel: React.FC<CarouselProps> = ({ elements }) => {
  const [activeElement, setActiveElement] = React.useState<number>(0);
  const theme = useTheme();

  const renderElements = () => {
    return elements.map((element, index) => (
      <Slide
        key={`slide-${index}`}
        style={{ display: index === activeElement ? "block" : "none"}}
        direction="left"
        in={index === activeElement}
      >
        {element}
      </Slide>
    ));
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent> ) => {
    const parent = e.currentTarget.parentNode!;
    const children = Array.from(parent.children);
    const index = children.indexOf(e.currentTarget);
    setActiveElement(index);
  };

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveElement((old) => {
        if((old + 1) >= elements.length){
          return 0
        }
        return old + 1
      });
    }, 10000)
    return () => clearInterval(intervalId)
  },[elements.length]);

  return (
    <Box>
      <StyledBox>{renderElements()}</StyledBox>
      <StyledMobileStepper
        theme={theme}
        variant="dots"
        steps={elements.length}
        position="static"
        activeStep={activeElement}
        nextButton={
          <></>
        }
        backButton={
          <></>
        }
        slotProps={{
          dot:{
            onClick: handleClick
          }
        }}
      />
    </Box>
  );
};

export default Carousel;
